export default __webpack_public_path__ + "static/media/skill-wordplay.9bd334a6.svg";